/* eslint-disable */
import { http } from '@/helpers/http';

const defaultAdvantage = {
  id: 'new',
  is_active: false,
  sort: '',
  name: '',
  alias: '',
  title: '',
  subtitle: '',
  description: null,
  icon: null
};

export default {
  namespaced: true,
  state() {
    return {
      list: [], // Список преимуществ компании
      search: '', // Поисковое слово в списке
      current: defaultAdvantage,
    };
  },

  mutations: {
    /* Записать новый список */
    setList (state, data) {
      state.list = data.slice();
    },

    /* Установить поисковое слово */
    setSearch (state, data) {
      state.search = data;
    },

    /* Установить свойство текущего объекта */
    setValue (state, payload) {
      state.current = {
        ...state.current,
        ...payload
      }
    },

    /* Очистить текущее значение */
    clearCurrent (state) {
      state.current = {
        ...state.current,
        ...defaultAdvantage
      }
    },

    /* Удалить из списка */
    removeFormList (state) {
      const index = state.list.findIndex(({id}) => id === state.current.id);
      state.list.splice(index, 1);
    },

    /* Установить текущий объект по идентификатору */
    setCurrent (state, _id) {
      const bank = state.list.find(({ id }) => id === _id )
      state.current = {
        ...state.current,
        ...bank
      }
    },

    /* Заменить по идентификатору */
    replaceById (state, current) {
      const index = state.list.findIndex(({ id }) => id === current.id);
      state.list.splice(index, 1, current);
    },

    /* Добавить в список */
    addList (state, current) {
      state.list.push({...current, id: state.list.length + 1 });
    }
  },

  getters: {
    // getList: state => state.list.filter(({ title }) => title.indexOf(state.search) >= 0),

    getList: state => state.list
    .filter(({ title }) => title.toLowerCase().indexOf(state.search.toLowerCase()) >= 0)
    .map(({ alias, id, is_active, title, updated_at_formatted }) => {
      return {
        id,
        title,
        alias,
        is_active: is_active ? 'Да' : 'Нет',
        updated_at: updated_at_formatted
      };
    }),

    getById: state => _id => state.list.find(({ id }) => id === _id ),

    getCurrent: state => state.current,

    getFormatList: (state, getters) => {
      return getters.getList.map(obj => ({
        ...obj,
        is_active: obj.is_active ? 'Да' : 'Нет'
      }))
    }
  },

  actions: {
    async getList({ commit }) {
      try {
        const { data } = await http.post('/admin/company-advantages');
        commit('setList', data);
      } catch (e) {
        throw e;
      }
    },

    async remove({ commit }, id) {
      await http.post('/admin/company-advantages/remove', { id });
      commit('clearCurrent');
    },

    async getById({ commit }, id) {
      if (id === null || id === 'new') {
        commit('clearCurrent');
        return;
      }

      const { data } = await http.post('/admin/company-advantages/edit', { id });
      commit('setValue', data);
    },

    async save({ state }) {
      // Это новый элемент или редактирование?
      const isNew = state.current.id === 'new' || state.current.id === null;

      if (!isNew) {
        const { data: id } = await http.post('/admin/company-advantages/store', {
          id: state.current.id,
          name: state.current.name,
          title: state.current.title,
          alias: state.current.alias,
          is_active: state.current.is_active,
          sort: +state.current.sort,
          description: state.current.description,
          icon: state.current.icon,
        });
        
        return id;
      } else {
        const { data: id } = await http.post('/admin/company-advantages/store', {
          name: state.current.name,
          title: state.current.title,
          alias: state.current.alias,
          is_active: state.current.is_active,
          sort: +state.current.sort,
          description: state.current.description,
          icon: state.current.icon,
        });
        return id;
      }
    }
  },
};
